module.exports = __webpack_public_path__ + "static/img/img26.bcddbff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img26.png
// module id = jSzZ
// module chunks = 1